module.exports = __webpack_public_path__ + "static/media/card-logo-mastercard.fcbe1cb0.svg";